import React, { useState } from "react";
import { Link } from "react-router-dom";

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-primary-color text-white">
      <div className="flex flex-wrap items-center justify-between max-w-screen-xl mx-4 sm:mx-4 md:mx-6 lg:mx-8 xl:mx-auto 2xl:mx-auto py-2.5">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src="Brandflow Logo.png"
            className="h-12 sm:h-16 md:h-16 lg:h-16 xl:h-16 2xl:h-18"
            // className="h-20 sm:h-24 md:h-28 lg:h-28 xl:h-28 2xl:h-32"
            alt="BrandFlow Logo"
          />
        </Link>

        {/* Mobile Menu Button */}
        <div className="flex items-center lg:order-2">
          <button
            onClick={toggleMenu}
            type="button"
            className="inline-flex items-center p-2 ml-1 text-sm text-secondary-color rounded-lg lg:hidden hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-gray-200 transition duration-300"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className={`w-4 h-4 sm:w-6 sm:h-6 ${isMenuOpen ? "hidden" : ""}`}
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
            <svg
              className={`${isMenuOpen ? "" : "hidden"} w-4 h-4 sm:w-6 sm:h-6`}
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>

        {/* Navbar Menu */}
        <div
          className={`items-center justify-center w-full lg:flex lg:w-auto lg:order-1 ${
            isMenuOpen ? "block" : "hidden"
          }`}
          id="mobile-menu-2"
        >
          <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0 lg:justify-center lg:w-full">
            <li>
              <Link
                to="/"
                className="block py-2 pl-3 pr-4 text-secondary-color bg-opacity-0 rounded hover:bg-secondary-color hover:text-white hover:bg-opacity-100 transition duration-300"
                aria-current="page"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="block py-2 pl-3 pr-4 text-secondary-color bg-opacity-0 rounded hover:bg-secondary-color hover:text-white hover:bg-opacity-100 transition duration-300"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/gallery"
                className="block py-2 pl-3 pr-4 text-secondary-color bg-opacity-0 rounded hover:bg-secondary-color hover:text-white hover:bg-opacity-100 transition duration-300"
              >
                Gallery
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="block py-2 pl-3 pr-4 text-secondary-color bg-opacity-0 rounded hover:bg-secondary-color hover:text-white hover:bg-opacity-100 transition duration-300"
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
